export const userGroupOptions = [
  {
    value: 1,
    label: 'Administrators',
    name: 'admin' as const,
  },
  {
    value: 2,
    label: 'Customer Head Admin',
    name: 'customer_head_admin' as const,
  },
  {
    value: 3,
    label: 'Customer Administrator',
    name: 'customer_admin' as const,
  },
  {
    value: 4,
    label: 'Head of Department',
    name: 'department_head' as const,
  },
  {
    value: 5,
    label: 'Head of Department Corp',
    name: 'department_head_corp' as const,
    deprecated: true,
  },
  {
    value: 6,
    label: 'Mobile User',
    name: 'mobile_user' as const,
  },
  {
    value: 7,
    label: 'Seller',
    name: 'seller' as const,
  },
  {
    value: 8,
    label: 'Management',
    name: 'management' as const,
    deprecated: true,
  },
  {
    value: 9,
    label: 'Dealer',
    name: 'dealer' as const,
    deprecated: true,
  },
  {
    value: 10,
    label: 'Report User',
    name: 'report_user' as const,
  },
  {
    value: 11,
    label: 'IT Worker',
    name: 'it_user' as const,
  },
  {
    value: 12,
    label: 'Financing Agent',
    name: 'financing_agent' as const,
    deprecated: true,
  },
]
